import {z} from "zod";
import {EASY_ONBOARD_API_KEY_PLACEHOLDER, EASY_ONBOARD_AWS_ACCESS_KEY_PLACEHOLDER, EASY_ONBOARD_AWS_SECRET_KEY_PLACEHOLDER} from "@/shared/lib/easyOnboardEmailDraft";

const draftSchema = z.object({
  version: z.literal(1), requestId: z.string().uuid(), attempted: z.boolean(),
  recipients: z.array(z.object({id: z.string(), name: z.string(), email: z.string()})).min(1).max(20),
  customCc: z.array(z.object({id: z.string(), email: z.string()})).max(20),
  organizationMode: z.enum(["new", "existing"]), organizationName: z.string(), organizationId: z.string(),
  product: z.enum(["world", "atlas", "world-atlas", "world-tickers"]), webApi: z.boolean(), datasetMode: z.enum(["none", "static", "live"]),
  trialDaysInput: z.string(), emailSubject: z.string().nullable(), emailBody: z.string().nullable(),
});
export type OnboardDraft = z.infer<typeof draftSchema>;
export const onboardDraftKey = (adminId: string) => `nosible:easy-onboard:v1:${adminId}`;

export function readOnboardDraft(storage: Pick<Storage, "getItem">, adminId: string): OnboardDraft | null {
  const value = storage.getItem(onboardDraftKey(adminId));
  if (!value) return null;
  // Corrupt recovery references must not silently become a fresh creation.
  return draftSchema.parse(JSON.parse(value));
}

export function credentialTemplate(value: string | null, result?: {apiKey: string | null; awsAccessKeyId: string | null; awsSecretAccessKey: string | null}): string | null {
  if (!value || !result) return value;
  for (const [secret, placeholder] of [
    [result.awsSecretAccessKey, EASY_ONBOARD_AWS_SECRET_KEY_PLACEHOLDER],
    [result.awsAccessKeyId, EASY_ONBOARD_AWS_ACCESS_KEY_PLACEHOLDER],
    [result.apiKey, EASY_ONBOARD_API_KEY_PLACEHOLDER],
  ]) if (secret) value = value.replaceAll(secret, placeholder!);
  return value;
}

export function writeOnboardDraft(storage: Pick<Storage, "setItem">, adminId: string, draft: OnboardDraft): void {
  // Whitelist the draft: never persist a result, signed email token or credentials.
  storage.setItem(onboardDraftKey(adminId), JSON.stringify(draftSchema.parse(draft)));
}
